var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgDlsHide = function SvgDlsHide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 15.98s-3.01-4.75-8.53-6.92L24 4h-4l-2.07 4.14C17.31 8.06 16.67 8 16 8 7.98 8 2 15.98 2 15.98v.04s3.43 4.57 8.59 6.79L8 28h4l2.09-4.17c.62.1 1.26.17 1.91.17 8.02-.02 14-7.98 14-7.98.01-.01-.1-.01-.3-.02.2-.01.31-.01.3-.02zM5 16c1.88-2.04 5.82-6 11-6 .33 0 .66.02.98.04L11.5 20.99C8.55 19.68 6.29 17.39 5 16zm11.01 6c-.33 0-.66-.02-.98-.05l5.52-11.05c3.18 1.3 5.29 3.7 6.45 5.1-1.85 2.01-5.78 5.99-10.99 6z"
  })));
};

export default __webpack_public_path__ + "static/media/DLS_Hide.8bd8d456.svg";
export { SvgDlsHide as ReactComponent };